export enum AlertText{
    DeletionError = 'Dein Objekt konnte nicht gelöscht werden. Bitte versuche es erneut.',
    SubscriptionWarning = 'Dein Vertrag konnte nicht beendet werden. Bitte versuche es erneut.',
    LoadingError = 'Deine Objekte konnten nicht geladen werden.',
    DeactivationError = 'Dein Objekt konnte nicht deaktiviert werden. Bitte versuche es erneut.',
    ActivationError = 'Dein Objekt konnte nicht aktiviert werden. Bitte versuche es erneut.',
    ObjectError = 'Deine Objekte konnte nicht geladen werden. Bitte versuche es erneut.'
}
